import { useState } from 'react';

function useSuggestionSelected(item) {
  const [value, setValue] = useState(item);
  return [value, setValue];
}
// eslint-disable-next-line import/prefer-default-export
export { useSuggestionSelected };
